
















































































































































































































































































































































import {Component, Inject, Vue} from 'vue-property-decorator';
import {
    addDealershipContact, deleteDealershipContact,
    getDealerInformation,
    getDealershipContacts,
    getVehicleHistoryForDateRange, searchByDealership,
    searchByEmail,
    sendDealershipVehicleEmailForDateRange, transferVehicleHistoryLogsToDealership,
    updateVehicleLogPreInspectionResponse
} from "../../endpoints";
import {
    Dealership as DealershipType,
    DealershipContact,
    DealershipViewType, getPreInspectionResponseLabel, getVehicleStateLabel, Permissions,
    PreInspectionResponse,
    VehicleFilter,
    VehicleLog
} from "../../types";
import DateFormat from "date-fns/format";
import DateSub from "date-fns/subDays";
import {serializeForm} from "../../util";
import Search from "@/components/utility/Search.vue";

Vue.component("v-search", Search);

@Component
export default class Dealership extends Vue {

    @Inject("hasPermission")
    hasPermission: Function;

    // Expose our constants
    Permissions = Permissions;
    DateFormat = DateFormat;
    VehicleFilter = VehicleFilter;
    SearchByEmail = searchByEmail;
    DealershipViewType = DealershipViewType;
    PreInspectionResponseType = PreInspectionResponse;
    GetVehicleStateLabel = getVehicleStateLabel;
    GetPreInspectionResponseLabel = getPreInspectionResponseLabel;
    SearchByDealership = searchByDealership;

    dealershipInformation: DealershipType = null;

    startDateModel = new Date();
    endDateModel = new Date();

    vehicles: VehicleLog[] = [];
    contacts: DealershipContact[] = [];
    vehiclesToProcess: VehicleLog[] = [];

    emails: string[] = [];
    emailModel: string = "";

    // Initial load
    loadingVehicles: boolean = true;
    submitted: boolean = false;
    view: DealershipViewType = DealershipViewType.NORMAL;

    vehicleFilterDropdownModel = VehicleFilter.ALL;

    contactToBeDeleted: DealershipContact | null = null;
    targetDealershipForTransfer: number | null = null;

    addContactForm: {
        firstName: string;
        lastName: string;
        title: string;
        cellNumber: string;
        workNumber: string;
        email: string;
        availability: string;
    } = {
        firstName: "",
        lastName: "",
        title: "",
        cellNumber: "",
        workNumber: "",
        email: "",
        availability: ""
    };

    async mounted() {
        const { uri } = this.$route.params;
        const { start, end, view } : any = this.$route.query;

        try {
            this.dealershipInformation = await getDealerInformation(uri);
            this.contacts = await getDealershipContacts(this.dealershipInformation.id);
        } catch (e) {
            console.error(e);
            return;
        }

        if(start && end) {
            const startDate = new Date(`${start}T00:00:00`);
            const endDate = new Date(`${end}T00:00:00`);

            // Ensure that the provided dates are valid before attempting to assign them.
            if(!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
                this.startDateModel = startDate;
                this.endDateModel = endDate;
            }
        } else {
            this.startDateModel = new Date();
            this.endDateModel = DateSub(new Date(), 7);
        }

        if(view) {
            if([
                VehicleFilter.ALL,
                VehicleFilter.SOLD,
                VehicleFilter.NEW,
                VehicleFilter.INSPECTED,
                VehicleFilter.NOT_READY,
                VehicleFilter.LIVE,
                VehicleFilter.DECLINED,
                VehicleFilter.APPROVED,
                VehicleFilter.FRONTLINE
            ].indexOf(view) !== -1) {
                this.vehicleFilterDropdownModel = view;
            }
        }

        this.onDateChange();
    }

    async onDateChange() {
        const params = new URLSearchParams();

        params.append("start", DateFormat(this.startDateModel, "yyyy-MM-dd"));
        params.append("end", DateFormat(this.endDateModel, "yyyy-MM-dd"));

        try {
            this.loadingVehicles = true;
            this.vehicles = await getVehicleHistoryForDateRange(this.dealershipInformation.id, params.toString());
        } catch (e) {
            console.error(e);
        } finally {
            this.loadingVehicles = false;
        }
    }

    async onConfirmContactCreationButtonClick() {
        const payload = JSON.stringify(serializeForm(this.$refs['create-contact-form'] as HTMLFormElement));

        this.submitted = true;

        try {
            await addDealershipContact(this.dealershipInformation.id, payload);

            (this.$refs['create-contact-modal'] as any).hide();

            this.contacts = await getDealershipContacts(this.dealershipInformation.id);
        } catch (e) {

        } finally {
            this.submitted = false;
        }
    }

    async onSubmitEmailRecipientsButtonClick() {

        this.submitted = true;

        try {
            await sendDealershipVehicleEmailForDateRange(
                this.dealershipInformation.id,
                JSON.stringify({
                    emails: this.emails,
                    vehicle_log_ids: this.vehiclesToProcess.map(u => { return u.id })
                })
            );

            (this.$refs["email-vehicles-modal"] as any).hide();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    onAddEmailRecipientButtonClick() {

        if(!this.emailModel.length) {
            return;
        }

        // TODO check if valid email

        this.emails.push(this.emailModel);
        this.emailModel = "";
    }

    deleteEmailRecipient(email: string) {
        this.emails = this.emails.filter(e => {
            return e !== email;
        });
    }

    async onPreInspectionButtonClick(vehicleLogId: number, response: PreInspectionResponse) {
        const result = await updateVehicleLogPreInspectionResponse(vehicleLogId, JSON.stringify({ response }));
        this.vehicles = this.vehicles.map(v => {
            return v.id === result.id ? result : v;
        });
    }

    onApprovalModeButtonClick() {
        if(this.view === DealershipViewType.APPROVAL) {
            this.view = DealershipViewType.NORMAL;
        } else {
            this.vehicleFilterDropdownModel = VehicleFilter.ALL;
            this.view = DealershipViewType.APPROVAL;
        }
    }

    async onDeleteContactButtonClick(contact: DealershipContact) {
        this.contactToBeDeleted = contact;
        (this.$refs["dealership-contact-delete-modal"] as any).show();
    }

    async onConfirmDeleteContactButtonClick() {
        this.submitted = true;
        this.contacts = await deleteDealershipContact(this.dealershipInformation.id, this.contactToBeDeleted.id);
        this.submitted = false;
        (this.$refs["dealership-contact-delete-modal"] as any).hide();
    }

    onEmailVehiclesButtonClick() {
        this.vehiclesToProcess = [...this.filteredVehicles];
        (this.$refs["email-vehicles-modal"] as any).show();
    }

    onTransferInventoryButtonClick() {
        this.vehiclesToProcess = [...this.filteredVehicles];
        (this.$refs["inventory-transfer-modal"] as any).show();
    }

    async onSubmitInventoryTransferButtonClick() {
        this.submitted = true;

        try {
            await transferVehicleHistoryLogsToDealership(
                this.targetDealershipForTransfer,
                JSON.stringify({
                    vehicle_log_ids: this.vehiclesToProcess.map(u => { return u.id })
                })
            );

            this.onDateChange();

            (this.$refs["inventory-transfer-modal"] as any).hide();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    deleteVehicleToProcess(vehicleHistoryId: number) {
        this.vehiclesToProcess = this.vehiclesToProcess.filter(v => {
            return v.id !== vehicleHistoryId;
        });

        if(!this.vehiclesToProcess.length) {
            (this.$refs["email-vehicles-modal"] as any).hide();
            (this.$refs["inventory-transfer-modal"] as any).hide();
        }
    }

    onDealershipResultSelected(item) {
        if(item) {
            this.targetDealershipForTransfer = item.id;
        } else {
            this.targetDealershipForTransfer = null;
        }
    }

    onVehicleTransferModalClosed() {
        this.targetDealershipForTransfer = null;
    }

    get filteredVehicles() {
        return this.vehicles.filter((vehicle: VehicleLog) => {

            const { last_pre_inspection_response, report_link } = vehicle;

            switch (this.vehicleFilterDropdownModel) {
                case VehicleFilter.APPROVED:
                    return last_pre_inspection_response === VehicleFilter.APPROVED;
                case VehicleFilter.DECLINED:
                    return last_pre_inspection_response === VehicleFilter.DECLINED;
                case VehicleFilter.NOT_READY:
                    return last_pre_inspection_response === VehicleFilter.NOT_READY;
                case VehicleFilter.LIVE:
                    return (!last_pre_inspection_response || last_pre_inspection_response === VehicleFilter.NOT_READY) && !report_link;
                case VehicleFilter.INSPECTED:
                    return report_link;
                case VehicleFilter.NEW:
                    return !last_pre_inspection_response;
                case VehicleFilter.SOLD:
                    return last_pre_inspection_response === VehicleFilter.SOLD;
                default:
                    return true;
            }
        })
    }
}
